/**
 * Normalizes the error thrown by the Orval fetcher into the API error body the service-type
 * error mappers expect.
 *
 * The fetcher rejects with an AppError ({ status, code, message, details, ... }). The QuickMD
 * API error body (ErrorCode / UserFriendlyErrorCode) lives on `details`, which is the exact
 * shape the old viewService/newService reducer + listener `*_ERROR` cases read from
 * `action.payload`. When `details` is unavailable the raw error is returned so the mapper
 * falls back to its default message handling.
 */
export function getServiceApiErrorBody(error: unknown): unknown {
  if (error && typeof error === 'object' && 'details' in error && error.details) {
    return error.details
  }
  return error
}
